export const AppActions = {
    APP_LOADING: "APP_LOADING",
    APP_ERROR: "APP_ERROR",
    STEP_2: "STEP_2"
}

export const verifyEmail = (email, history) => (dispatch) => {
    dispatch({
        type: AppActions.STEP_2,
        payload: null
    });
    return new Promise((resolve, reject) => {
        resolve();
    })
}


// WEBPACK FOOTER //
// ./src/app/root/app.actions.js